import * as $ from 'jquery';
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { BroadcastService } from '../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../../services/infrastructure/config.service';
import { ExcelService } from '../../../../services/infrastructure/excel.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { StockTransferAddProductSliderModelService } from './sot-add-product.component-slider-model.service';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../common/components/filter/filter-enum';
import { SOTService } from '../../../../services/seed/sot/sot.service';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-sot-add-product',
  templateUrl: './sot-add-product.component.html',
  styleUrls: ['./sot-add-product.component.scss']
})

export class StockTransferAddProductComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  accountInvoicedDS: any;
  displayedColumns: string[] = ['Product Name', 'Pack Size', 'Lot Number', 'Treatment', 'Product Line', 'Availability'];
  filters: any;
  filterOptionsData: Array<FilterOption>;
  headerCompany = MasterConstants.US_COMPANYCODE;
  isProductNotAdded = true;
  itemList = new Array();
  parentAccountDS: any;
  parentProductList: any;
  productList: any;
  selectedProductList = new Array();
  selectedTabIndex = 0;
  tabProductList: any;

  constructor(
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private excelService: ExcelService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private sotService: SOTService,
    private stockTransferAddProductSliderModelService: StockTransferAddProductSliderModelService,
    private toastrService: ToastrService
  ) {
  }

  // ngOnInit
  ngOnInit() {

    const filters: any = {};
    filters.showFavoriteOnly = false;

    this.setFilter();
    this.getAllProducts(false);
    this.setDropDownValues();
  }

  setFilter() {
    this.filterOptionsData = [
      { label: 'Product Name', key: 'productName', controlType: ControlType.Text },
      { label: 'Product Line', key: 'productLine', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Lot #', key: 'lotNumber', controlType: ControlType.Text, controlDataBindLabel: 'value', controlDataBindValue: 'value' },
      { label: 'Item #', key: 'itemNumber', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'value' },
      { label: 'Package Size', key: 'packageSize', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Treatment', key: 'treatment', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Marketing Brand', key: 'marketingBrand', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
    ];
  }

  // Set Drop down values for filter
  setDropDownValues() {
    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST)) {
      this.filterOptionsData.find(x => x.key === 'marketingBrand').controlData = JSON.parse(this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST)) {
      this.filterOptionsData.find(x => x.key === 'packageSize').controlData = JSON.parse(this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.filterOptionsData.find(x => x.key === 'treatment').controlData = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    // Product Line data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.filterOptionsData.find(x => x.key === 'productLine').controlData = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }

    // Item Number master data
    if (this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.filterOptionsData.find(x => x.key === 'itemNumber').controlData = JSON.parse(this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST));
    }
  }

  // search in master search area
  filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.itemDescription.toLocaleLowerCase().indexOf(term) > -1;
  }

  // search in master search area
  filterUOMFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.id.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Search the account details on shipto / Deliverto dropdown
  productSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.itemDescription.toLocaleLowerCase().indexOf(term) > -1
      || item.itemNumber.toLocaleLowerCase().indexOf(term) > -1
      || item.itemVendorName.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Selected product will add on order
  addSelectedProductToOrder() {
    const data = [];
    if (this.selectedProductList.length > 0) {// Addition use case implemented asked in bug 74741
      this.selectedProductList.forEach(x => {
        const duplicateData = data.find(y => y.itemNumber == x.itemNumber && y.orderUOM == x.orderUOM && y.lotNumber == x.lotNumber);
        if (duplicateData) {
          if (!duplicateData.isParent && this.selectedTabIndex === 1) {
            var index = data.indexOf(duplicateData);
            if (index !== -1) {
              data.splice(index, 1);
            }
            data.push(x);
          }
          else if (duplicateData.isParent && this.selectedTabIndex === 0) {
            var index = data.indexOf(duplicateData);
            if (index !== -1) {
              data.splice(index, 1);
            }
            data.push(x);
          }
        }
        else {
          data.push(x);
        }
      });
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: data.length, isSOT: true, labelNo: 'No, go back to Request' });
    }
    this.stockTransferAddProductSliderModelService.setData<StockTransferAddProductSliderModelService[]>(data);
    this.stockTransferAddProductSliderModelService.stockTransferClose();
  }

  // Filter Search
  filterSearchClick(event) {
    this.filters = {
      accountNumber: this.sotService.getSelectedAccountNo(),
      productName: event.productName,
      marketingBrand: event.marketingBrand,
      packageSize: event.packageSize,
      treatment: event.treatment,
      productLine: event.productLine,
      itemNumber: event.itemNumber,
      lotNumber: event.lotNumber
    };

    this.getAllProducts(true);
  }

  getAllProducts(isFilter) {
    if (!isFilter) {
      this.filters = {
        accountNumber: this.sotService.getSelectedAccountNo(),
      };
    }

    this.filters.companyCode = this.headerCompany;
    this.filters.shipToAccount = this.stockTransferAddProductSliderModelService.shipToAccount;
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.sotService.getProductMaster(this.filters).subscribe((result: any) => {
      if (result && result.length > 0) {
        this.tabProductList = result;
        this.loaderService.setLoaderStatus(false);

        this.productList = this.tabProductList.filter(x => x.isParent == false);
        this.accountInvoicedDS = new MatTableDataSource(this.productList);

        this.parentProductList = this.tabProductList.filter(x => x.isParent == true);
        this.parentAccountDS = new MatTableDataSource(this.parentProductList);

        this.tabProductList.forEach(x => {
          if (this.selectedProductList.filter(y => y.itemNumber == x.itemNumber && y.lotNumber == x.lotNumber && y.orderUOM == x.orderUOM).length > 0) {
            x.IsProductSelected = true;
          }
          else {
            x.IsProductSelected = false;
          }
        });
        this.loaderService.setLoaderStatus(false);
      }
      else {
        this.toastrService.info('No records found.');
        this.productList = [];
        this.accountInvoicedDS = new MatTableDataSource(this.productList);
        this.parentAccountDS = new MatTableDataSource(this.productList);
        this.loaderService.setLoaderStatus(false);
      }
      this.setAccInvProdTableHeight();
      this.setcompInvProdTableHeight();
    }, (error) => {
      this.productList = [];
      this.accountInvoicedDS = new MatTableDataSource([]);
      this.parentAccountDS = new MatTableDataSource([]);
      this.toastrService.error('No records found.');
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Enable or disable Add product to order btn based on item selection
  enableDisableAddProductBtn() {
    if (this.selectedProductList.length > 0) {
      this.isProductNotAdded = false;
    }
    else {
      this.isProductNotAdded = true;
    }
  }

  filterClearAllClick(event) {
    this.getAllProducts(false);
  }

  // Clear Grid data
  clearGridData(filters) {
    this.productList = [];
    this.accountInvoicedDS = new MatTableDataSource(this.productList);
    this.parentProductList = [];
    this.parentAccountDS = new MatTableDataSource(this.parentProductList);

    if (filters) {
      this.getAllProducts(filters);
    }
  }

  filterProductGridData(filters) {
    if (filters.clearAll == false) {
      this.setAccInvProdTableHeight();
      if (!this.validateProductFilter(filters)) {
        this.toastrService.error('Value must greater than equal to 2 characters.');
        return true;
      }
      this.getAllProducts(filters);
    }
    else {
      this.productList = [];
      this.accountInvoicedDS = new MatTableDataSource(this.productList);
      filters.clearAll = false;

      const filter: any = {};
      filter.showFavoriteOnly = true;
      this.setAccInvProdTableHeight();
      this.getAllProducts(filter);
    }
    this.enableDisableAddProductBtn();
  }

  // Update selected prodcut list
  keepRecords(product, isProductTab) {
    product.IsProductSelected = !product.IsProductSelected;
    const itemNumber = product.itemNumber;
    const availableQuantity = product.availableQuantity;
    const lotNumber = product.lotNumber;
    const orderUOM = product.orderUOM;
    const isParent = product.isParent;
    if (product.IsProductSelected) {
      // remove item if already selected
      var index = this.itemList.findIndex(x => x.itemNumber == itemNumber && x.orderUOM == orderUOM && x.lotNumber == lotNumber && x.availableQuantity == availableQuantity);
      if (index !== -1) {
        this.itemList.splice(index, 1);
      }
      index = this.selectedProductList.findIndex(x => x.itemNumber == itemNumber && x.orderUOM == orderUOM && x.lotNumber == lotNumber && x.availableQuantity == availableQuantity);
      if (index !== -1) {
        this.selectedProductList.splice(index, 1);
      }
      let item;
      if (isProductTab) {
        item = this.parentProductList.filter(i => i.itemNumber == itemNumber && i.orderUOM == orderUOM && i.lotNumber == lotNumber && i.availableQuantity == availableQuantity && i.isParent == !isParent);
      } else {
        item = this.productList.filter(i => i.itemNumber == itemNumber && i.orderUOM == orderUOM && i.lotNumber == lotNumber && i.availableQuantity == availableQuantity && i.isParent == !isParent);
      }
      if (item.length > 0) {
        item[0].IsProductSelected = false;
      }

      // Select the clicked object into array
      this.itemList.push({ 'itemNumber': itemNumber, 'availableQuantity': availableQuantity, 'lotNumber': lotNumber, 'orderUOM': orderUOM });
      if (isProductTab) {
        item = this.productList.filter(i => i.itemNumber == itemNumber && i.orderUOM == orderUOM && i.lotNumber == lotNumber && i.availableQuantity == availableQuantity && i.isParent == isParent);
      } else {
        item = this.parentProductList.filter(i => i.itemNumber == itemNumber && i.orderUOM == orderUOM && i.lotNumber == lotNumber && i.availableQuantity == availableQuantity && i.isParent == isParent);
      }
      this.selectedProductList.push(item[0]);
    }
    else {
      var index = this.itemList.findIndex(x => x.itemNumber == itemNumber && x.orderUOM == orderUOM && x.lotNumber == lotNumber && x.availableQuantity == availableQuantity);
      if (index !== -1) {
        this.itemList.splice(index, 1);
      }
      index = this.selectedProductList.findIndex(x => x.itemNumber == itemNumber && x.orderUOM == orderUOM && x.lotNumber == lotNumber && x.availableQuantity == availableQuantity);
      if (index !== -1) {
        this.selectedProductList.splice(index, 1);
      }
    }
    this.enableDisableAddProductBtn();
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
    if (this.selectedTabIndex === 0) {
      this.setAccInvProdTableHeight();
    } else if (this.selectedTabIndex === 1) {
      this.setcompInvProdTableHeight();
    }
  };

  // set Add product table height
  setAccInvProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.sot-add-prod .accInvProdTable').css('max-height', tableHeight + 'px');
  }

  setcompInvProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.sot-add-prod .compInvProdTable').css('max-height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccInvProdTableHeight();
    this.setcompInvProdTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    //this.setAccInvProdTableHeight();
    //this.setcompInvProdTableHeight();
  }

  // ngOnDestroy
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  export() {
    const exportData = [];
    this.loaderService.setLoaderStatus(true);

    if (this.selectedTabIndex === 0 && this.productList && this.productList.length > 0) {
      const filteredList = this.productList.filter(x => x.displayMessage == null);
      filteredList.forEach(x => {
        exportData.push({
          'Product Name': `${x.itemVendorName}/${x.itemDescription}`,
          'Item Number': x.itemNumber,
          'Available Units': x.availableUnits,
          'Pack Size': x.packageSize,
          'Product Line': x.productLine
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'AccountProductsReport');
    } else if (this.selectedTabIndex === 1 && this.parentProductList && this.parentProductList.length > 0) {
      const filteredList = this.parentProductList.filter(x => x.displayMessage == null);
      filteredList.forEach(x => {
        exportData.push({
          'Product Name': `${x.itemVendorName}/${x.itemDescription}`,
          'Item Number': x.itemNumber,
          'Available Units': x.availableUnits,
          'Pack Size': x.packageSize,
          'Product Line': x.productLine
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'ParentProductsReport');
    }

    this.loaderService.setLoaderStatus(false);
  }

  isDisableExportButton(): boolean {
    let retVal = true;

    if (this.selectedTabIndex === 0 && this.productList) {
      retVal = this.productList.filter(x => x.displayMessage == null).length === 0;
    } else if (this.selectedTabIndex === 1 && this.parentProductList) {
      retVal = this.parentProductList.filter(x => x.displayMessage == null).length === 0;
    }

    return retVal;
  }

  isShowExportButton(): boolean {
    return [0, 1].includes(this.selectedTabIndex);
  }

  getSelectedCount() {
    const distinctThings = this.selectedProductList.filter((thing, i, arr) => arr.findIndex(x => x.itemNumber === thing.itemNumber && x.orderUOM === thing.orderUOM && x.lotNumber == thing.lotNumber) === i);
    return distinctThings.length;
  }

  // to validate product filter
  validateProductFilter(productFilter) {
    let isValid = false;

    // To Validate MarketingBrand
    if (productFilter.itemNo != null && productFilter.itemNo.length > 0) {
      isValid = true;
    }

    // To Validate ProductName
    if (productFilter.productName !== null && productFilter.productName !== '' && productFilter.productName.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate ActiveIngredient
    if (productFilter.activeIngredient !== null && productFilter.activeIngredient !== '' && productFilter.activeIngredient.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Vendor
    if (productFilter.vendor !== null && productFilter.vendor !== '' && productFilter.vendor.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Gtin
    if (productFilter.gtin !== null && productFilter.gtin !== '' && productFilter.gtin.toString().trim().length >= 2) {
      isValid = true;
    }
    // To Validate ProductLine
    if (productFilter.productLine !== null && productFilter.productLine !== '' && productFilter.productLine.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate PackageSize
    if (productFilter.packageSize !== null && productFilter.packageSize !== '' && productFilter.packageSize.toString().trim().length >= 2) {
      isValid = true;
    }

    if (productFilter.productName == null
      && (productFilter.itemNo == null || productFilter.itemNo.length <= 0)
      && productFilter.activeIngredient == null
      && productFilter.vendor == null
      && productFilter.gtin == null
      && productFilter.productLine == null
      && productFilter.packageSize == null) {
      isValid = false;
    }
    return isValid;
  }
}
